import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Pagination,
  Avatar,
} from "@mui/material";
import { residential_enquiry_list } from "../../../api/ControllApi";

const ResidentialEnqueryList = () => {
  const [enquiryList, setEnquiryList] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(0);

  /* ================= GET LIST ================= */
  const getEnquiryList = () => {
    setLoading(true)
    residential_enquiry_list()
      .then((res) => {
        setEnquiryList(res?.data?.plot || []);
        setRowsPerPage(res?.data?.pagination.per_page)
      })
      .catch((err) => {

      }).finally(() => {
        setLoading(false)
      })
  };

  useEffect(() => {
    getEnquiryList();
  }, []);

  /* ================= SEARCH FILTER ================= */
  const trimmedSearch = search.trim().toLowerCase();

  const filteredData = enquiryList.filter((item) => {
    if (!trimmedSearch) return true;

    const propertyName = item?.plot?.property_name || "";
    const createdAt = item?.created_at || "";

    return (
      propertyName.toLowerCase().includes(trimmedSearch) ||
      createdAt.toLowerCase().includes(trimmedSearch)
    );
  });


  /* ================= PAGINATION ================= */
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  const isVideo = (url) => {
    if (typeof url !== 'string') return false;
    return url.match(/\.(mp4|webm|mkv|mov|avi)$/i);
  };

  /* File image */
  const getFileImage = (plot) => {
    const images = Array.isArray(plot?.thumbnail) ? plot.thumbnail : [plot?.thumbnail].filter(Boolean);

    if (images.length > 0) {
      // Find first non-video image
      const firstImage = images.find(file => !isVideo(file));
      if (firstImage) return firstImage;

      // If all are videos, return the first one
      return images[0];
    }

    return "/assets/images/no-image.png";
  };

  return (
    <Box>
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
          mb: 2,
        }}
      >
        <Typography variant="h5" fontWeight={600}>
          Flats / Villas Enquiry List
        </Typography>

        <TextField
          label="Search Flats / Villas Enquiry..."
          variant="outlined"
          size="small"
          sx={{ width: { xs: "100%", sm: 250 } }}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </Box>

      {/* TABLE */}
      <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "primary.light"}}>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              {/* <TableCell><strong>ID</strong></TableCell> */}
              <TableCell><strong>Property Name</strong></TableCell>
              <TableCell><strong>Date Of Enquiry</strong></TableCell>
              <TableCell><strong>Image</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? <TableRow>
              <TableCell colSpan={4} align="center">
                Loading..
              </TableCell>
            </TableRow> :
              paginatedData.length > 0 ? (
                paginatedData.map((enq) => (
                  <TableRow key={enq.id}>
                    {/* ID */}
                    {/* <TableCell>{enq.id}</TableCell> */}



                    {/* PROPERTY NAME */}
                    <TableCell>
                      {enq?.plot?.property_name || "-"}
                    </TableCell>

                    {/* CREATED DATE */}
                    <TableCell>
                      {enq?.created_at
                        ? new Date(enq.created_at).toLocaleDateString("en-GB")
                        : "-"}
                    </TableCell>

                    {/* THUMBNAIL */}
                    <TableCell>
                      <Avatar
                        src={getFileImage(enq?.plot)}
                        variant="rounded"
                        sx={{ width: 60, height: 50 }}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No Flat/Villas Enquery List Found
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* PAGINATION */}
      {!loading && filteredData.length > rowsPerPage && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={Math.ceil(filteredData.length / rowsPerPage)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
      {/* <Box display="flex" justifyContent="center" mt={2}>
        <Pagination
          count={Math.ceil(filteredData.length / rowsPerPage)}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
        />
      </Box> */}
    </Box>
  );
};

export default ResidentialEnqueryList;
